<template>
  <DialogModal :show="messageStore.messageControl.show" @close="closeModal">
    <template #title>
      <div class="w-full flex items-center justify-end gap-2">
        <div
          v-if="messageStore.messageControl.type === 'error'"
          class="absolute top-0 left-0 w-full h-6 rounded-t-lg bg-red-500"
        ></div>
        <div
          v-else-if="messageStore.messageControl.type === 'warning'"
          class="absolute top-0 left-0 w-full h-6 rounded-t-lg bg-yellow-400"
        ></div>
        <h1 dir="rtl" class="font-semibold text-2xl">
          {{ messageStore.messageControl.type === 'error' ? "خطأ" : messageStore.messageControl.type === 'warning' ? "تحذير" : 'معلومة' }}
        </h1>
      </div>
    </template>
    <template #content>
      <div class="w-full flex-col items-center justify-center p-4" dir="rtl">
        <p>{{ messageStore.messageControl.message }}</p>
      </div>
    </template>
    <template #footer>
      <div class="w-full flex flex-col justify-between items-center gap-3 p-4">
        <button @click="closeModal" class="w-full text-sm font-semibold border text-white p-3 text-center rounded" :class="messageStore.messageControl.type === 'error' ? 'bg-red-500' : messageStore.messageControl.type === 'warning' ? 'bg-yellow-400' : 'bg-tazej-gray-300'">
          حسنا
        </button>
      </div>
    </template>
  </DialogModal>
</template>

<script setup>
import { watch } from "vue";
import { useMessageStore } from '@/stores/message.store';
import DialogModal from './DialogModal.vue';
import { reportClientError } from '@/helpers/errorTracking.js';

const messageStore = useMessageStore();

watch(
  () => [
    messageStore.messageControl.show,
    messageStore.messageControl.type,
    messageStore.messageControl.message,
  ],
  ([show, type, message]) => {
    if (!show || (type !== "error" && type !== "warning") || !message) {
      return;
    }
    reportClientError({
      source: "ui_modal",
      severity: type,
      description: message,
    });
  }
);

function closeModal() {
  messageStore.messageControl.show = false;
}
</script>

<style scoped>
.w-full.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
</style>
